import {Routes,Route} from 'react-router-dom'
import { NavBar } from './components/NavBar';
import { About } from './pages/About';
import { ContactUs } from './pages/ContactUs';
import {Home} from "./pages/Home"
import { Projects } from './pages/Projects';
import './App.css';
import { Education } from './pages/Education';
import { Experience } from './pages/Experience';
import { ProjectsAllDetails } from './pages/ProjectALlDetails';
function App() {
  return (
    <div className="App">
      <NavBar/>
      
      <Routes>
         <Route path='/' element={<Home/>}></Route>
         <Route path='/about' element={<About/>}></Route>
         <Route path='/education' element={<Education/>}></Route>
         <Route path='/experience' element={<Experience/>}></Route>
         <Route path='/projects' element={<Projects/>}></Route>
         <Route path='/contact' element={<ContactUs/>}></Route>
         <Route path='/project_details' element={<ProjectsAllDetails/>}></Route>
         
      </Routes>
    </div>
  );
}

export default App;
